export function SelectElement(selector: string) {
  return function (target: any, propertyKey: string) {
    const privatePropertyKey = `_${propertyKey}`;

    Object.defineProperty(target, propertyKey, {
      get: function () {
        if (!this[privatePropertyKey]) {
          const rootNode = this instanceof Element ? this : document.body;
          const element = queryDeepSelectorAll(selector, rootNode);
          if (!element) {
            throw new Error(`Element with selector "${selector}" not found.`);
          }
          this[privatePropertyKey] = element;
        }
        return this[privatePropertyKey];
      },
      set: function (newValue) {
        this[privatePropertyKey] = newValue;
      },
      enumerable: true,
      configurable: true
    });
  };
}

function queryDeepSelectorAll(selector: string, rootNode: Element, all = false) {
  const arr: any[] = [];
  const traverser = (node: any) => {
    if (!all && arr.length) { return; }

    // decline all nodes that are not elements
    if (node.nodeType !== Node.ELEMENT_NODE) { return; }

    // add the node to the array, if it matches the selector
    if (node.matches(selector)) {
      arr.push(node);
      if (!all) { return; }
    }

    // loop through the children
    const children = node.children;
    if (children.length) {
      for (const child of children) {
        traverser(child);
      }
    }
    // check for shadow DOM, and loop through it's children
    const shadowRoot = node.shadowRoot;
    if (shadowRoot) {
      const shadowChildren = shadowRoot.children;
      for (const shadowChild of shadowChildren) {
        traverser(shadowChild);
      }
    }
  };
  traverser(rootNode);
  return all ? arr : (arr.length ? arr[0] : null);
}
